// extracted by mini-css-extract-plugin
export default {"icons":"PropertiesCard_icons__9dJXL","greyText":"PropertiesCard_greyText__QMEVk"};